import React from 'react';

function CookieConsentBanner({ visible, onAccept, onDecline }) {
  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      left: '16px',
      right: '16px',
      bottom: '16px',
      zIndex: 2000,
      backgroundColor: '#111827',
      color: '#ffffff',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.25)'
    }}>
      <div style={{ fontSize: '15px', lineHeight: 1.5 }}>
        Мы используем cookies для аналитики и улучшения работы сервиса.
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '12px', flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={onAccept}
          style={{
            border: 'none',
            backgroundColor: '#16a34a',
            color: '#fff',
            borderRadius: '8px',
            padding: '10px 14px',
            cursor: 'pointer'
          }}
        >
          Принять
        </button>
        <button
          type="button"
          onClick={onDecline}
          style={{
            border: '1px solid #4b5563',
            backgroundColor: 'transparent',
            color: '#fff',
            borderRadius: '8px',
            padding: '10px 14px',
            cursor: 'pointer'
          }}
        >
          Отклонить
        </button>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
